import React from 'react'
import Header from '../Header'
import HeadingAndDate from '../Pagination/HeadingAndDate'

const MainHeader = (props) => {
  const { headingAndDate = true, heading, datePicker = true } = props
  return (
    <div>
      <Header />
      {headingAndDate && <HeadingAndDate heading={heading} datePicker={datePicker} />}
    </div>
  )
}

export default MainHeader
